import {
  validateNotExistUser,
  zohoDataSend,
  zohoPymesDataSend,
  signupUser,
  orderConekta,
  customerConekta,
  customerConektaPymes,
  accountSignupUrl,
  accountMeUrl,
  login,
  resetPassowrdUrl,
  setPassowrdUrl,
  validateEmailUrl,
  validateNotExistUserRFC,
  automaticBillingUrl,
  getCFDIUseByFiscalRegimeUrl,
  validateUserFielUrl,
  confirmationRFCCompanyNameURL,
  getTokenInfo,
  newPaymentUser,
  getNewConektaUserOrder,
  tokenBusinessPayment,
  activateBusinessSubscriptionUrl,
  getNewConektaBusinessOrder,
  validateCouponUrl,
  tokenPayment,
  checkRecaptchaGoogle,
  emailPayment,
  sendNewPaymentReference,
  allMyAccountCFDICount,
  accountRFCInfo,
  fielSingUp,
  sendMailValidate,
  decodeTokenInfoUser,
  activateEmailUser,
  updateAllInfoUser,
  getAccountsZoho,
  allPricesPackages,
  getMyCurrentSubscription,
  verifyCode, enableTwoFactorAuth, logbookEntry, sendMailValidatePymesUrl,
} from './endpoints'
import request from '@/utils/request'
//import {logbookEntry} from "../invoices/endpoints";


export const getAllPackagesPrices = () => {
  return request(allPricesPackages, {
    method: 'POST',
  })
}


export const sendEmailToValidateInfoUser = (email, companyName) => {
  return request(sendMailValidate, {
    method: 'POST',
    body: {
      'email': email,
      'companyName': companyName,
    },
  })
}

export const sendEmailToValidateInfoUserPymes = (email, pymes) => {
  return request(sendMailValidatePymesUrl, {
    method: 'POST',
    body: {
      'email': email,
      'pymes_type': pymes,
    },
  })
}


export const decodeInfoForValidate = (token) => {
  return request(decodeTokenInfoUser, {
    method: 'POST',
    body: {
      'token': token,
    },
  })
}

export const activateEmailUserInformation = (name) => {
  return request(activateEmailUser, {
    method: 'POST',
    body: {
      'companyName': name,
    },
  })
}

export const updateUserInfo = (obj) => {
  return request(updateAllInfoUser, {
    method: 'POST',
    body: obj,
  })
}

export const sendEmailSubscriptionPaymentLogin = (email, option) => {
  return request(emailPayment, {
    method: 'POST',
    body: {
      'email': email,
      'option': option,
    },
  })
}

export const sendVerificateCode2fa = (token, code) => {
  return request(verifyCode, {
    method: 'POST',
    body: { token, code },
  })
}

export const sendPaymentReference = (order, reference, is_pymes=null, email=null) => {
  return request(sendNewPaymentReference, {
    method: 'POST',
    body: {
      'order': order,
      'reference': reference,
      'is_pymes': is_pymes,
      'email':email
    },
  })
}

export const tokenInfoUser = (tokenUsr) => {
  return request(getTokenInfo, {
    method: 'POST',
    body: {
      'token': tokenUsr,
    },
  })
}

export const validateRecaptchaGoogle = (captcha) => {
  return request(checkRecaptchaGoogle, {
    method: 'POST',
    body: {
      'recaptcha_response': captcha,
    },
  })
}

export const getTokenComponentRenewPayment = (email) => {
  return request(tokenPayment, {
    method: 'POST',
    body: {
      'email_user': email,
    },
  })
}

export const decryptionBusinessToken = (token) => {
  return request(tokenBusinessPayment, {
    method: 'POST',
    body: {
      'token': token,
    },
  }).then((res) => {
    return res.data.info
  }).catch(() => {
    return null
  })
}


export const uploadFIELSingUp = (body) => {
  return request(fielSingUp, {
    method: 'POST',
    body,
    isUpload: true,
  })
}

export const getRFCIdUser = (name) => {
  return request(accountRFCInfo, {
    method: 'POST',
    body: { 'name': name },
  })
    .then((res) => {
      return res.data.result
    })
    .catch(() => {
      return null
    })
}

export const getAllMyCountCFIDS = (name) => {
  return request(allMyAccountCFDICount, {
    method: 'POST',
    body: { 'accountName': name },
  })
    .then((res) => {
      return res.data.detail
    }).catch(() => {
      return null
    })
}

export const GetMyCurrentSub = (name) => {
  return request(getMyCurrentSubscription, {
    method: 'POST',
    body: { 'accountName': name },
  })
    .then((res) => {
      return res.data.detail
    }).catch(() => {
      return null
    })
}


export const activateBusinessSubscription = (name, isNew) => {
  return request(activateBusinessSubscriptionUrl, {
    method: 'POST',
    body: {
      'name': name,
      'new': isNew,
    },
  }).then((res) => {
    return res.data.info
  }).catch(() => {
    return null
  })
}

export const createNewSuscription = (id, name, payment) => {
  return request(newPaymentUser, {
    method: 'POST',
    body: {
      'accound_id': id,
      'codename': name,
      'payment': payment
    },
  })
}

export const getNewConektaOrderInfo = (id, rfc, id_user) => {
  return request(getNewConektaUserOrder, {
    method: 'POST',
    body: {
      'order_id': id,
      'rfc': rfc,
      'user_id': id_user,
    },
  })
}

export const getBusinessConektaOrderInfo = (id) => {
  return request(getNewConektaBusinessOrder, {
    method: 'POST',
    body: {
      'order_id': id,
    },
  }).then((res) => {
    return res.data.info
  }).catch(() => {
    return null
  })
}


export function userLogin(username, email, password, ipAddr) {
  return request(login, {
    method: 'POST',
    body: {
      username,
      email,
      password,
      ipAddr,
    },
  })
}

export const sendZohoInfo = (obj, flow = 'leads') => {
  return request(`${zohoDataSend}?flow=${flow}`, {
    method: 'POST',
    body: obj,
  })
}

export const sendZohoInfoPyme = (obj) => {
  return request(`${zohoPymesDataSend}`, {
    method: 'POST',
    body: obj,
  })
}

export const getAccountsZohoInfo = (query) => {
  return request(`${getAccountsZoho}?query=${query}`, {
    method: 'GET',
  })
}

export const validateUser = (dataUser) => {
  return request(validateNotExistUser, {
    method: 'POST',
    body: dataUser,
  })
}

export const validateUserdataRFC = (dataUser) => {
  return request(validateNotExistUserRFC, {
    method: 'POST',
    body: dataUser,
  })
}

export function validateEmail(token) {
  return request(validateEmailUrl, {
    method: 'POST',
    body: { token },
  })
}

export function validateEmailAccount(email) {
  return request(`${validateEmailUrl}?email=${email}`)
}

export function validateCoupon(code, subscription_type) {
  return request(validateCouponUrl, {
    method: 'POST',
    body: { code, subscription_type },
  })
}

export function validateFiel(data) {
  return request(validateUserFielUrl, {
    method: 'POST',
    body: data,
    isUpload: true,
  })
}

export const createCustomerConketa = (
  first, last, email, type, coupon,
  isPyme = false, price = null, packageName=null,
  phoneNumber=null) => {
  return request(customerConekta, {
    method: 'POST',
    body: {
      first_name: first,
      last_name: last,
      email: email,
      type: type,
      coupon: coupon,
      is_pyme: isPyme,
      price: price,
      package_name: packageName,
      phone_number: phoneNumber,

    },
  })
}

export const signUp = (obj) => {
  return request(signupUser, {
    method: 'POST',
    body: {
      regimen_name: obj.regimen_name,
      first_name: obj.first_name,
      last_name: obj.last_name,
      phone_number: obj.phone_number,
      account_name: obj.account_name,
      username: obj.username,
      rfc: obj.rfc,
      email_address: obj.email_address,
      password: obj.password,
      package_code_name: obj.subscription_type_code_name,
      payment_type: obj.payment_type,
      postal_code: obj.postal_code,
      coupon_code: obj.coupon_code,
      vendor_code: obj.vendor_code,
    },
  })
}

export const getCustomerOrder = (id, rfcUser, viewType, email=null, pymesType=null, phone_number=null) => {
  return request(orderConekta, {
    method: 'POST',
    body: {
      'order_id': id,
      'rfc': rfcUser,
      'view': viewType,
      'email': email,
      'pymes_type': pymesType,
      'phone_number':phone_number
    },
  })
}

export function getUserAndAccountData(token) {
  return request(accountMeUrl, { token: token })
}

export function resetPassword(email) {
  return request(resetPassowrdUrl, {
    method: 'POST',
    body: {
      email:email,
    },
  })
}

export function setPassword(password, confirmPassword, JWTToken) {
  return request(setPassowrdUrl, {
    method: 'POST',
    token: JWTToken,
    body: {
      password,
      confirm_password: confirmPassword,
    },
  })
}

export function accountSignup(
  accountName,
  accountRfc,
  emailAddress,
  password,
  confirmPassword,
  packageCodeName,
  couponCode = null,
) {
  let payload = {
    account_name: accountName,
    rfc: accountRfc,
    email_address: emailAddress,
    password: password,
    confirm_password: confirmPassword,
    package_code_name: packageCodeName,
  }
  if (couponCode) {
    payload.coupon_code = couponCode
  }
  return request(accountSignupUrl, {
    method: 'POST',
    body: payload,
  })
}

export function automaticBilling(obj) {
  return request(automaticBillingUrl, {
    method: 'POST',
    body: obj,
  })
}

export function getCFDIUseByFiscalRegime(obj) {
  return request(getCFDIUseByFiscalRegimeUrl, {
    method: 'POST',
    body: obj,
  })
}

export function confirmationRFCCompanyName(obj) {
  return request(confirmationRFCCompanyNameURL, {
    method: 'POST',
    body: obj,
  })
}

export function activateTwoFactorAuth(email) {
  return request(enableTwoFactorAuth, {
    method: 'POST',
    body: { email },
  })
}

export function createLogbookEntry(data) {
  return request(logbookEntry, {
    method: 'POST',
    body: data
  });
}
